import { axios } from '../config/axios';

const endPoint = 'project/candidate-user';

const getListAllByPage = async ( searchTerm, pageNumber, limit) => {
  return axios.post(`${endPoint}/list-all-with-pagination`, { 
    search: searchTerm,
    page: pageNumber,
    limit: limit
 });
}

// upload (processing flow - csv only)
const uploadProcessingCandidate = async (formData) => {
    return axios.post(`${endPoint}/upload-candidates-user`, formData);
};

// upload (direct add + images)
const uploadCandidate = async (candidateMasterId, formData) => {
  return axios.put(`${endPoint}/upload-candidate/${candidateMasterId}`, formData);
};

const downloadCandidatesCsv = () => {
    return axios.get(`${endPoint}/download-candidate-user-csv`, {
        responseType: 'blob',
        headers: {
            'Cache-Control': 'no-cache'
        }
    });
};

const downloadCandidateTemplate = () => {
    return axios.get(`${endPoint}/download-candidate-template`, {
        responseType: 'blob'
    });
}


//// clear logged in count
export {
    getListAllByPage,
    uploadProcessingCandidate,
    uploadCandidate,
    downloadCandidatesCsv,
    downloadCandidateTemplate
};

